import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InitialRouteReportComponent } from './initial-route-report.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomInputModule } from "src/app/shared/components/custom-input/custom-input.module";
import { MaterialModule } from "src/app/shared/material/material.module";
import { CustomDropdownModule } from "src/app/shared/components/custom-dropdown/custom-dropdown.module";



@NgModule({
  declarations: [
    InitialRouteReportComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomInputModule,
    MaterialModule,
    CustomDropdownModule
],
  exports:[
    InitialRouteReportComponent
  ]
})
export class InitialRouteReportModule { }
